import React, { useRef } from "react";
import JoditEditor from "jodit-react";

//reactstrap
import {
    Row,
    Col,
    FormGroup,
    Label,
    Input
} from "reactstrap";

//Config
import * as Config from "@constants/Config";

const TransitionPage = (props) => {
    const editor = useRef(null);

    //props
    const { handleChangeMessage, data } = props && props;
    const Messages = data?.Messages;
    const TransitionMessage = Messages?.TransitionMessage;
    const title = TransitionMessage?.title;
    const text = TransitionMessage?.text;

    return (
        <Row>
            <Col md={6}>
                <FormGroup>
                    <Label for="Title">
                        Title:
                    </Label>
                    <Input
                        id="Title"
                        name="Title"
                        placeholder=""
                        type="text"
                        value={title}
                        onChange={(e) => handleChangeMessage('TransitionMessage', 'title', e.target.value)}
                        autoComplete="off"
                    />
                </FormGroup>
            </Col>
            <Col md={12}>
                <FormGroup>
                    <Label for="Message">
                        Message:
                    </Label>
                    <JoditEditor
                        ref={editor}
                        value={text}
                        name={`TransitionMessage`}
                        config={Config.CONFIG_JODIT}
                        tabIndex={1} // tabIndex of textarea
                        onBlur={(newContent) => handleChangeMessage('TransitionMessage', 'text', newContent)}
                    />
                </FormGroup>
            </Col>
        </Row>
    );
};

export default TransitionPage;